// Router de plataforma para Auth. Re-exporta el tipo `Session` para que el
// resto del código siga importándolo de './Auth' sin cambios.
import { lazy, Suspense } from 'react';
import { isWeb } from '../platform';

const AuthWeb = lazy(() => import('./Auth.web'));
const AuthMobile = lazy(() => import('./Auth.mobile'));

export default function Auth(
  props: React.ComponentProps<typeof import('./Auth.shared').default>,
): JSX.Element {
  const View = isWeb() ? AuthWeb : AuthMobile;
  return (
    <Suspense fallback={null}>
      <View {...props} />
    </Suspense>
  );
}

export type { Session } from './Auth.shared';
